module.exports = __webpack_public_path__ + "img/card3.31ea808c.png";